import { render, staticRenderFns } from "./compare-two.vue?vue&type=template&id=613a8d12"
import script from "./compare-two.vue?vue&type=script&lang=js"
export * from "./compare-two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports